import { Typography } from "@circle-react-uikit/Typography";

import { t } from "@/i18n-js/instance";
import { isAnnual } from "@/react/helpers/planHelpers";

import { usePlans } from "../../../RegularPlan/PlansContext";

export const PlanPrice = () => {
  const { selectedPlan } = usePlans();
  if (!selectedPlan) return null;

  return (
    <div className="flex flex-row gap-1">
      {isAnnual(selectedPlan.interval) && (
        <>
          <Typography.BodyXs color="text-default">
            <span className="line-through">
              {selectedPlan.strike_through_price}
            </span>
          </Typography.BodyXs>
          <Typography.BodyXs color="text-default">
            {t("pricing_plans.plan_settings.plan_summary.plan_annual_amount", {
              amount: selectedPlan.display_base_monthly_amount,
            })}
          </Typography.BodyXs>
        </>
      )}
    </div>
  );
};
